/* eslint-disable */
import React from "react";
import { useOutletContext } from "react-router-dom";
import ParentMonthlyReportsSection from "../components/parent/ParentMonthlyReportsSection";

export default function ParentReports() {
  const { profile, activeChild } = useOutletContext();

  const schoolId = profile?.schoolId || activeChild?.schoolId || "";
  const selectedChild = activeChild || null;

  return (
    <div style={{ padding: 16 }}>
      <ParentMonthlyReportsSection
        schoolId={schoolId}
        selectedChild={selectedChild}
        overrideTestMode={false}
        title="Monthly Reports"
      />
    </div>
  );
}